import React from 'react';
import styles from './styleConstants.module.css';

const cx = (...classes: (string | undefined | false)[]) =>
  classes.filter(Boolean).join(' ');

/* ── Typography ───────────────────────────────────────── */

/** 14px uppercase label — used above headings */
export const SectionLabel = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p ref={ref} {...props} className={cx(styles.sectionLabel, className)} />
));
SectionLabel.displayName = 'SectionLabel';

/** 48px / 32px section heading */
export const SectionHeading = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h2 ref={ref} {...props} className={cx(styles.sectionHeading, className)} />
));
SectionHeading.displayName = 'SectionHeading';

/** 16px body text */
export const SectionBody = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p ref={ref} {...props} className={cx(styles.sectionBody, className)} />
));
SectionBody.displayName = 'SectionBody';

/** 16px / 14px card title */
export const CardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p ref={ref} {...props} className={cx(styles.cardTitle, className)} />
));
CardTitle.displayName = 'CardTitle';

/** 16px / 14px card body text */
export const CardBody = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p ref={ref} {...props} className={cx(styles.cardBody, className)} />
));
CardBody.displayName = 'CardBody';

/* ── Layout ───────────────────────────────────────────── */

/** Centered text block used above section content */
export const SectionTextBlock = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} {...props} className={cx(styles.sectionTextBlock, className)} />
));
SectionTextBlock.displayName = 'SectionTextBlock';
